/**
 * Deterministic pseudo-random number generator (mulberry32 variant).
 * Uses only 32-bit integer operations so output is identical in every engine.
 */
export class Rng {
  state: number;

  constructor(seed: number) {
    this.state = seed >>> 0 || 0x9e3779b9;
  }

  nextU32(): number {
    let t = (this.state = (this.state + 0x6d2b79f5) >>> 0);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return (t ^ (t >>> 14)) >>> 0;
  }

  /** Integer in [0, n). */
  int(n: number): number {
    return n <= 0 ? 0 : this.nextU32() % n;
  }

  /** Integer in [lo, hi]. */
  range(lo: number, hi: number): number {
    return lo + this.int(hi - lo + 1);
  }

  /** Returns true with probability num/den. */
  chance(num: number, den: number): boolean {
    return this.int(den) < num;
  }

  /** Float in [0,1). Only for non-authoritative use (map decoration, rendering). */
  float(): number {
    return this.nextU32() / 4294967296;
  }
}

/** Stateless integer hash for procedural generation. */
export function hash2(x: number, y: number, seed: number): number {
  let h = Math.imul(x | 0, 374761393) ^ Math.imul(y | 0, 668265263) ^ Math.imul(seed | 0, 0x27d4eb2d);
  h = Math.imul(h ^ (h >>> 13), 1274126177);
  return (h ^ (h >>> 16)) >>> 0;
}
